import { render, staticRenderFns } from "./menu-info.vue?vue&type=template&id=5ef6504e&"
import script from "./menu-info.vue?vue&type=script&lang=js&"
export * from "./menu-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menu-info.vue"
export default component.exports